(function() {
	'use strict';
	angular.module('app.setup')
		.controller('strategicGoals', strategicGoals);
	
	strategicGoals.$inject = ['$scope', '$rootScope', '$timeout', '$compile', '$uibModal', '$filter', 'storeService',
		'tableService', 'leanFilterService', 'leanTableService', 'strategicGoalsService', 'tableRenderService'];
	function strategicGoals($scope, $rootScope, $timeout, $compile, $uibModal, $filter, storeService,
			tableService, leanFilterService, leanTableService, strategicGoalsService, tableRenderService) {
		var vm = this;
		var adminConfig = storeService.getState().adminConfig;
		var reportSettingsName = 'StrategicGoals';
		var getSpecialControl;
		// Extra query params to send to backend in data requests
		var extraParams = [{
			'name': 'showArchive',
			'value': false
		}];
		var rendererParams = {};

		$scope.filterService = leanFilterService;
		$scope.processArchive = processArchive;

		vm.useSiteSwitcher = true;
		vm.showExcel = false;
		vm.isAdmin = $rootScope.authz.isAdmin();
		vm.showAddStrategicGoals = vm.isAdmin;
		vm.addStrategicGoals = addStrategicGoals;
		vm.deleteStrategicGoal = deleteStrategicGoal;
		vm.updateStrategicGoalStatus = updateStrategicGoalStatus;
		vm.showStrategicGoalProjects = showStrategicGoalProjects;
		vm.getMeta = getMeta;
		vm.getData = getData;
		vm.reportName = 'Strategic Goals';

		function getMeta() {
			return meta;
		}

		function getData(params, extraParams) {
			return tableService.getData(params, extraParams).then(function (response) {
				// If any data manipulation is needed, do it here
				return response;
			});
		}

		var columns = [
			{
				'id': 'name',
				'display': 'Name',
				'renderer': tableRenderService.strategicGoalRenderer,
				'deleteFunction': 'deleteStrategicGoal',
				'requiredPermission': 'admin',
				'width': 400
			},
			{
				'id': 'description',
				'display': 'Description',
				'width': 300
			},
			{
				'id': 'type',
				'display': 'Goal Type',
				'width': 225
			},
			{
				'id': 'stateType',
				'display': 'Archived',
				'width': 100
			}
		];

		var meta = {
			reportSettingsName: reportSettingsName,
			reportName: vm.reportName,
			reportUrl: '{0}/StrategicGoals',
			noPaging: true,
			columns: columns,
			pinnedColumns: [],
			defaultSort: 'name',
			defaultSortDirection: 'asc',
			extraParams: extraParams,
			rendererParams: rendererParams,
			hideSearch: false,
			searchType: 'goal',
			setColumnDefaults: true
		};

		var getSpecialControls = function () {
			var specialControl = document.getElementById('specialControls');

			if (specialControl) {
				clearInterval(getSpecialControl);
				addSpecialControl();
			}
		};

		function addSpecialControl() {
			$scope.showArchive = false;
			var template = '<div style=\"display: inline-block;bottom: 0px;vertical-align: bottom;line-height: 27px;position: absolute;\">' +
				'<span style=\"font-weight:bold;font-size:14px;\" translate>Show Archived</span> <input type=\"checkbox\" ng-change=\"processArchive()\" ng-model=\"showArchive\"></div>';
			var compiledDiv = $compile(template)($scope);

			jQuery('#specialControls').append(compiledDiv);
		}

		function processArchive() {
			var showArchiveIndex = _.findIndex(extraParams, ['name', 'showArchive']);
			if (showArchiveIndex !== -1) {
				extraParams[showArchiveIndex].value = $scope.showArchive;
			} else {
				extraParams.push({
					'name': 'showArchive',
					'value': $scope.showArchive
				});
			}
			$scope.$broadcast('reloadTable');
		}

		function init() {
			getSpecialControl = setInterval(getSpecialControls, 200);
			$scope.filterService.clearFilters();
			$scope.filterService.useAdminFactory = true;
		}

		function addStrategicGoals(goal) {
			var goalFormScope = $scope.$new();
			goalFormScope.goal = jQuery.extend({}, goal);
			goalFormScope.action = (typeof goalFormScope.goal.ndx !== 'undefined' ? 'Edit' : 'Add');
			goalFormScope.leanDirFactoryNdx = vm.leanDirFactoryNdx;
			var opts = {
				scope: goalFormScope,
				templateUrl: '/application/f/setup/metricsAndGoals/strategic-goal-form.html',
				size: 'lg',
				backdrop: 'static'
			};

			var instance = $uibModal.open(opts);
			goalFormScope.closeDialog = function() {
				instance.close();
				goalFormScope.$destroy();
			};

			goalFormScope.result = function(message, isSuccessful) {
				$rootScope.$emit('toast', {'message': message, 'success': isSuccessful});
				if (isSuccessful) {
					$scope.$broadcast('reloadTable');
				}
				instance.close();
				goalFormScope.$destroy();
			};
		}

		function updateStrategicGoalStatus(goal) {
			var confirmScope = $scope.$new();
			var status = goal.stateType == 'Open' ? 'archive' : 'activate';
			var statusResult = goal.stateType == 'Open' ? 'archived' : 'activated';
			confirmScope.additionalText = status + ' this goal';
			confirmScope.buttonText = goal.stateType == 'Open' ? 'Archive' : 'Activate';
			var opts = {
				scope: confirmScope,
				templateUrl: '/application/f/core/confirm.html'
			};

			var instance = $uibModal.open(opts);
			confirmScope.closeDialog = function() {
				instance.close();
				confirmScope.$destroy();
			};

			confirmScope.yes = function() {
				instance.close();
				confirmScope.$destroy();
				var goalObj = {};
				goalObj.ndx = goal.ndx;
				goalObj.stateType = goal.stateType == 'Open' ? 'Archived' : 'Open';
				var lastModified = (typeof goal.lastModified === 'undefined') ? (new Date()).toUTCString(): (new Date(goal.lastModified)).toUTCString();

				strategicGoalsService.updateGoal(goalObj, lastModified, adminConfig.factory.id).then(function(message) {
					var isSuccessful = message.data.id == goalObj.ndx;
					$rootScope.$emit('toast', {'message': 'Goal ' + statusResult + ' successfully', 'success': isSuccessful});
					if (isSuccessful) {
						$scope.$broadcast('reloadTable');
					}
				});
			};
		}


		function deleteStrategicGoal(goalNdx) {
			var confirmScope = $scope.$new();
			confirmScope.goalNdx = goalNdx;
			confirmScope.additionalText = 'delete this goal';
			confirmScope.buttonText = 'Delete';
			var opts = {
				scope: confirmScope,
				templateUrl: '/application/f/core/confirm.html'
			};

			var instance = $uibModal.open(opts);
			confirmScope.closeDialog = function() {
				instance.close();
				confirmScope.$destroy();
			};

			confirmScope.yes = function() {
				var goalNdx = confirmScope.goalNdx;
				instance.close();
				confirmScope.$destroy();
				strategicGoalsService.deleteGoal(goalNdx, adminConfig.factory.id).then(function(message) {
					var isSuccessful = (message == 'Goal deleted successfully');
					$rootScope.$emit('toast', {'message': message, 'success': isSuccessful});
					if (isSuccessful) {
						$scope.$broadcast('reloadTable');
					}
				});
			};
		}

		function openProjectsModel(projects) {
			var propjectsScope = $scope.$new();
			var opts = {
				scope: propjectsScope,
				templateUrl: '/application/f/setup/metricsAndGoals/strategic-goal-projects.html',
				size: 'lg',
				backdrop: 'static'
			};

			var instance = $uibModal.open(opts);
			propjectsScope.close = function() {
				instance.close();
				propjectsScope.$destroy();
			};

			propjectsScope.projects = projects;
		}

		function showStrategicGoalProjects(goalNdx) {
			strategicGoalsService.getGoalProjects(goalNdx, adminConfig.factory.id)
				.then(function(response) {
					if (response.data && response.data.length > 0) {
						openProjectsModel(response.data);
					} else {
						openProjectsModel([]);
					}
				});
		}

		init();
	}
})();
